module.exports = __webpack_public_path__ + "img/mikmic-1.a0640ca4.png";